// Imported from the concrete module (not the `core/helpers` barrel) to keep
// this package cycle-safe, matching the other mask files.
import { formatPhoneInput } from 'core/helpers/phoneNumberFormatter'

import { InputMask } from './types'

// Mirrors TextInput's historical `format='phone'` behavior byte-for-byte.
//
// LEGACY QUIRK: unlike the other masks, the STORED value is the formatted
// display string (e.g. `(415) 555 - 1234`), not raw digits — every existing
// caller depends on receiving the formatted value from `onChange`. `format` is
// therefore the identity, and `caretBehavior: 'end'` preserves the historical
// jump-to-end caret on reformat.
export const phoneFormat: InputMask = {
  sanitize: (input) => formatPhoneInput(input),
  format: (raw) => raw,
  placeholder: '(000) 000 - 0000',
  caretBehavior: 'end',
}
